import { Pipe, PipeTransform } from "@angular/core";
import { TicketZeit } from "../_interfaces/TicketTime";

import dayjs from '../_utils/dayjs.config';
import { TicketEditService } from "../_provider/ticket-edit.service";
import { TicketEmployee } from "../_provider/tickets/ticket.service";
import { EditArt } from "../_interfaces/EditArt";


    @Pipe({
        name: "timeDifference"
    })
    export class timeDifference implements PipeTransform{
        /**
         * Gibt die Different von 2 Daten an in ausgewählten Format
         * @param {TicketZeit} time TicketZeit aus denen berechnet werden soll
         * @param {string[]} args Format in das gewandelt werden soll
         * @example {{time | timerDifference: 'HH:MM:YYYY'}}
         * @returns {string} formatiertes Datum
         */
        public transform(time: TicketZeit, ...args: string[]): string {
            //damit es mit 00:00:00 anfängt sonst steht am anfang 59:59:59 da
            const timeTo = dayjs(time.timeTo).isBefore(time.timeFrom) ? dayjs(time.timeFrom) : dayjs(time.timeTo)
            
            return dayjs(timeTo.diff(dayjs(time.timeFrom))).add(-1, "hour").format(args[0]).toString()
        }
    }

    @Pipe({
        name: "timeIntervalDifference"
    })
    export class timeIntervalDifference implements PipeTransform{

        constructor(
            private ticketEditSrv: TicketEditService,
            private ticketSrv: TicketEmployee.TicketService
        ){}

        /**
         * berechnet anhand des Intervalls der Ticketsart die Gesamtzeit
         * @param {TicketZeit} time Zeiten Die berechnet werden sollen
         * @param {string[0]} args Format welchen zurückh´gegeben werden soll
         * @param {string[1]} args Art ID (optional)
         * @example {{time | timerDifference: 'HH:MM:YYYY'}}
         * @returns {string} formatiertes Datum
         */
        public transform<T = String>(time: TicketZeit, ...args: T[]): string | number {
            return timeIntervalDifference.TranformTime(time, args, this.ticketEditSrv.ticketArts, (args[1] ? args[1] : this.ticketSrv.ticketArt.id) as number)
        }

        /**
         * Static Function für berechnet anhand des Intervalls der Ticketsart die Gesamtzeit
         * @param {TicketZeit} time Zeiten Die berechnet werden sollen
         * @param {T = String} args Arguments für Funktion
         * @param {string[0]} args Format welchen zurückh´gegeben werden soll
         * @param {string[1]} args Art ID (optional)
         * @param {EditArt[]} ticketArts Von Server geholten Berabeitungs-Arten
         * @param {number} ticketArtId Art des Tickets
         * @returns {string} formatiertes Datum
         */
        public static TranformTime<T = String>(time: TicketZeit, args: T[], ticketArts: EditArt[], ticketArtId: number): string | number {
            let minutes: number = dayjs(time.timeTo).diff(dayjs(time.timeFrom), "minute", true)

            let interval: number = 1
            if(time?.customInterval > 0) interval = time.customInterval ?? 1
            else interval = ticketArts.find(ta => ta.id == ticketArtId)?.interval ?? 1

            const formattedMinutes: number = Math.ceil(minutes / interval) * interval
            if(typeof args[0] == "string") return dayjs.utc(formattedMinutes * 60 * 1000).format(String(args[0])).toString()
            else return formattedMinutes
        }
    }

    @Pipe({
        name: "timeFormat"
    })
    export class FormatTime implements PipeTransform{

        /**
         * Gibt formatiertes Datum zurück
         * @param {Date} date datum welches formatiert werden soll 
         * @param {string[]} args Farmat in das es formatiert werden soll 
         * @example {{time | TimeFormat: 'HH:MM:YYYY'}}
         * @returns {string} formatiertes Datum
         */
        transform(date: Date, ...args: any[]): string {
            if((dayjs(date).isSame("0001-01-01"))) return ""
            return `${dayjs(date).format(args[0] as string).toString()} ${args[1] as boolean == true ? "Uhr" : ""}`
        }
    }

    @Pipe({
        name: "taskName"
    })
    export class TaskName implements PipeTransform{

        constructor(private ticketSrv: TicketEmployee.TicketService){}

        /**
         * Gibt die Bezeichnung eines Tasks anhand eine ID
         * @param {number} id Id des Tasks 
         * @param args 
         * @returns 
         */
        transform(id: number, ...args: any[]) {
            return this.ticketSrv.tasks.find(t => t.id == id)?.description || ""
        }

    }

    @Pipe({
        name: "secondsToTimeString"
    })
    export class SecondsToTimeString implements PipeTransform{
            
            /**
            * Gibt die Zeit in String zurück
            * @param {number} seconds Zeit in Sekunden
            * @param {string[]} args Format in das es formatiert werden soll 
            * @example {{time | SecondsToTimeString: 'HH:MM:YYYY'}}
            * @returns {string} formatiertes Datum
            */
            transform(seconds: number, ...args: any[]): string {
                return dayjs.utc(seconds * 1000).format(args[0] as string).toString()
            }
    }
